import { render, staticRenderFns } from "./register-form.vue?vue&type=template&id=02579790&scoped=true&"
import script from "./register-form.vue?vue&type=script&lang=js&"
export * from "./register-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02579790",
  null
  
)

export default component.exports